import { useSiteSettings } from '../../context/SiteSettingsProvider/SiteSettingsProvider';
import NioBrand from '../NioBrand/NioBrand';

export default function AuthLogo() {
  const { settings } = useSiteSettings();
  return <NioBrand customSrc={settings.siteLogoUrl || '/images/logo-jassp.png'} href="/" />;
}
